import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';

import { rootRouteRef } from './routes';

const RadarIcon = () => (
  <svg
    aria-hidden="true"
    focusable="false"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    fill="currentColor"
  >
    <path d="M12 2a10 10 0 1 0 10 10h-2a8 8 0 1 1-8-8V2z" />
    <path d="M12 6a6 6 0 1 0 6 6h-2a4 4 0 1 1-4-4V6z" />
    <path d="M12 10a2 2 0 1 0 2 2h-2v-2z" />
    <path d="M13 11.59 20.07 4.5l1.41 1.41L14.41 13H13v-1.41z" />
  </svg>
);

export const page = PageBlueprint.make({
  params: {
    path: '/tech-radar',
    routeRef: rootRouteRef,
    title: 'Tech Radar',
    icon: <RadarIcon />,
    loader: () =>
      import('./components/TechRadarPage').then(m => (
        <m.TechRadarPage />
      )),
  },
});

export const techRadarPlugin = createFrontendPlugin({
  pluginId: 'tech-radar',
  extensions: [page],
  routes: {
    root: rootRouteRef,
  },
});